<template>
  <view-with-bar>
    <template slot="bar">
      <view-bar>
        <h1>{{ $t('cashflow.reports') }}</h1>
        <view-bar-item :route="'/cash-flow/report/'+report.id" v-for="report in sortedReportDefinitions"
                       @heat="() => $router.push(`/cash-flow/heat/${report.id}`)" :actions="cashflowActions"
        >{{ report.name }}
        </view-bar-item>
        <h1>{{ $t('cashflow.configuration') }}</h1>
        <view-bar-item route="/cash-flow/definitions">{{ $t('cashflow.reportDefinitions') }}</view-bar-item>
        <h1>{{ $t('cashflow.cashEventsAndEffects') }}</h1>
        <view-bar-item route="/cash-flow/cash-events">{{ $t('cashflow.cashEvents') }}</view-bar-item>
        <view-bar-item route="/cash-flow/cash-effects">{{ $t('cashflow.effects') }}</view-bar-item>
      </view-bar>
    </template>
  </view-with-bar>
</template>

<script>
import ViewBar from "../components/navigation/ViewBar";
import ViewWithBar from "../components/layout/ViewWithBar";
import ViewBarItem from "../components/navigation/ViewBarItem";
import {mapGetters} from "vuex";

export default {
  name: "CashflowView",
  components: {ViewBarItem, ViewWithBar, ViewBar},
  computed: {
    ...mapGetters({
      operationDefinitions: "operationDefinitions/operationDefinitions",
      cashflowReports: "cashflowReportDefinitions/cashflowReportDefinitions"
    }),
    sortedReportDefinitions() {
      return [ ... this.cashflowReports].sort((a,b) => a.order - b.order);
    }
  },
  data: function() {
    return {

    }
  }
}
</script>

<style scoped>

</style>
